import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { IonCol, IonGrid, IonRow } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { IncidenceButtonComponent } from '../../incidence-button/incidence-button.component';
import { FreightDocumentationLinksComponent } from '../../freight-documentation/freight-documentation-links/freight-documentation-links.component';
import {
  EFreightForCarrierStatus,
  getEmptyFreightDetailedForCarrier,
  IFreightBasicForCarrier,
  transformToIFreightBasicFromIFreightDetailForCarrier,
} from '@okcargo-apps/shared-domain';
import { ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { AccountService } from '../../account';
import { FreightCarrierStopButtonComponent } from '../freight-carrier-stop-button/freight-carrier-stop-button.component';
import { IFreightCarrierDetailedVM } from '../freight-carrier-store.model';

@Component({
  selector: 'lib-freight-carrier-detail-footer-buttons',
  templateUrl: './freight-carrier-detail-footer-buttons.component.html',
  styleUrls: ['./freight-carrier-detail-footer-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    IonRow,
    IonCol,
    IonGrid,
    TranslateModule,
    FreightCarrierStopButtonComponent,
    FreightDocumentationLinksComponent,
    IncidenceButtonComponent,
  ],
})
export class FreightCarrierDetailFooterButtonsComponent {
  // comes from the hosting page, which composes the detail VM (item + delivery notes)
  public readonly itemVM = input.required<IFreightCarrierDetailedVM>();

  private readonly accountService = inject(AccountService);

  public readonly freight = computed(() => this.itemVM().item);

  public readonly freightBasic = computed<IFreightBasicForCarrier>(() =>
    transformToIFreightBasicFromIFreightDetailForCarrier(this.freight() ?? getEmptyFreightDetailedForCarrier()),
  );

  public readonly freightStatus = EFreightForCarrierStatus;

  protected readonly canInteractWithStops = computed(() =>
    this.accountService.hasCapability(ECapabilities.INTERACT_WITH_STOPS),
  );

  public isStopButtonActive(): boolean {
    const status = this.freightBasic().status;
    return status === EFreightForCarrierStatus.ASSIGNED || status === EFreightForCarrierStatus.ON_ROUTE;
  }
}
